import React from 'react';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';
import { useTheme } from '../../../../theme';
import Link from '../../../../Link';
import { CdnIcon } from '@shared/ui';
import { InfoMessagePositionsEnum } from '@websky/graphql';
import InfoMessages from '../../../../InfoMessages';
const Footer = ({ isLoading, error, notes, isFullFareConditions, onLinkClick }) => {
    const { t } = useTranslation('CompareFares');
    const { Footer: css } = useTheme('CompareFares');
    if (isLoading && error) {
        return null;
    }
    return (React.createElement(React.Fragment, null,
        isFullFareConditions && notes && (React.createElement("div", null,
            React.createElement("h6", { className: css.notesHeading }, t(notes.heading)),
            React.createElement("ul", { className: css.notesList }, notes.notesList.map((note, index) => (React.createElement("li", { key: index, className: css.notesListItem },
                index + 1,
                ". ",
                t(note))))))),
        React.createElement(InfoMessages, { position: InfoMessagePositionsEnum.compareTable, className: css.infoMessage, itemClassName: css.infoMessage__item, htmlClassName: css.infoMessage__html }),
        React.createElement(Link, { action: onLinkClick, className: css.link },
            React.createElement("span", { className: css.link__wrapper },
                React.createElement("span", { className: css.linkTitle }, isFullFareConditions ? t('Go back') : t('View full fare conditions')),
                React.createElement("span", { className: cn(css.linkIcon, { [css.linkIcon_return]: isFullFareConditions }) }, React.createElement(CdnIcon, { icon: "Arrow/Chevron_right" }))))));
};
export default Footer;
